import { useEffect, useState } from 'react';
import requiredFieldConfigRaw from '../../data/requiredFieldConfig';
import { fieldReader } from '../../services/loanApi';
import { getAccessToken } from '../../services/authApi';
import LoadingOverlay from '../shared/LoadingOverlay';
import { collectConditionFields, evaluateShowIfCondition } from '../../utils/conditionUtils';

const OrderCreditValidationRenderer = ({ config }) => {
    const [loading, setLoading] = useState(true);
    const [visibleGroups, setVisibleGroups] = useState([]);

    const init = async () => {
        try {
            window.elli?.script?.guest?.create?.();
            const loanObject = await window.elli.script.getObject("loan");
            const loan = await loanObject.all();

            const authObject = await window.elli.script.getObject("auth");
            const authCode = await authObject.createAuthCode();
            const accessToken = await getAccessToken(authCode);

            const fieldIds = [
                ...new Set([
                    "CX.LOAN.TYPE",
                    "CX.TPOC.OVERRIDE.VALIDATIONS",
                    ...config.FieldGroups.flatMap(group => collectConditionFields(group.ShowIf)),
                ])
            ];

            const values = await fieldReader(accessToken, fieldIds, loan.id);

            const skipModules =
                (values["CX.TPOC.OVERRIDE.VALIDATIONS"] || "").toString().trim().toUpperCase() === "Y";

            const loanType = values["CX.LOAN.TYPE"];

            const groups = config.FieldGroups
                .filter(g => !g.LoanType || g.LoanType === loanType)
                .filter(g => !(skipModules && (g.Type || "").toLowerCase() === "module"))
                .filter(g => !g.ShowIf || evaluateShowIfCondition(g, values));

            setVisibleGroups(groups);
        } catch (error) {
            console.error("Error initializing Order/ Reissue Credit validation page:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        init();
    }, []);

    return (
        <>
            <LoadingOverlay loading={loading} text="Loading..." />

            <div className="space-y-10 p-25px">
                <div className="rounded-lg p-3 space-y-6 max-w-8xl mx-auto">
                    <h2 className="page-title">{config?.Header}</h2>

                    {visibleGroups.map((group, index) => (
                        <div key={index} className="border border-blue-200 rounded bg-gray-50 mt-5">
                            <div className="section-header">{group.Group}</div>
                            {group.Notes && (
                                <div
                                    className="text-sm text-red-700 font-semibold italic px-4 py-4 whitespace-pre-line"
                                    dangerouslySetInnerHTML={{ __html: group.Notes }}
                                />
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

const OrderCreditValidate = () => {
    const config = requiredFieldConfigRaw.Pages.find(p => p.Page === 'Order/ Reissue Credit');
    return <OrderCreditValidationRenderer config={config} />;
};

export default OrderCreditValidate;
